import {createSelector, MemoizedSelector,} from '@ngrx/store';
import {rolesAdapter, RolesState} from './roles.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {Role} from '../../../../../core';

export const getError = (state: RolesState): any => state.error;

export const getIsLoading = (state: RolesState): boolean => state.isLoading;

export const selectRolesState = createSelector(selectFeatures,
  (state: FeaturesState) => state.roles
);

export const selectAllRoles: (state: object) => Role[] = rolesAdapter.getSelectors(
  selectRolesState
).selectAll;

export const selectRoleById = (id: string) =>
  createSelector(
    selectAllRoles,
    (allRoles: Role[]) => {
      if (allRoles) {
        return allRoles.find(p => p.rolId === id);
      } else {
        return null;
      }
    }
  );

export const selectRolesIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectRolesState,
  getIsLoading
);

